import React from 'react';
import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import ProfileDetails from './profileDetails';
import Engagements from './engagements';
import Collections from './collections';
import KeyInsightDetails from './keyInsightDetails';
import Recommended from './recommended';
import useProfilePanel from './useProfilePanel';

const row = {
    display: 'grid',
    gap: 2.5,
    mt: 2.5,
};

function ProfilePanel() {
    const { profileDisplay, collections, recommendedPublishers } = useProfilePanel();

    function renderHeader() {
        return (
            <Box sx={{ mb: 4 }}>
                <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2.16px', color: 'var(--ecal-lightblue)', mb: 0.5 }}>
                    Manage My ECAL · My profile
                </Typography>
                <Typography sx={{ fontWeight: 600, color: 'var(--ecal-white)', fontSize: '36px' }}>
                    Hello,{' '}
                    <Box component="span" sx={{ background: 'linear-gradient(90deg, #00D7FF, #0078FF)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
                        {profileDisplay.firstName || 'there'}
                    </Box>
                </Typography>
                <Typography sx={{ color: 'var(--ecal-lightgrey)', mt: 1, fontSize: '16px' }}>
                    Your ECAL profile, your engagement, and your collection — at a glance.
                </Typography>
            </Box>
        );
    }

    function renderTopRow() {
        return (
            <Box sx={{ ...row, gridTemplateColumns: { xs: '1fr', lg: '1fr 2fr' } }}>
                <ProfileDetails
                    displayName={profileDisplay.displayName}
                    email={profileDisplay.email}
                    avatarInitials={profileDisplay.avatarInitials}
                    personaType={profileDisplay.personaType}
                    role={profileDisplay.role}
                    city={profileDisplay.city}
                    country={profileDisplay.country}
                    timezone={profileDisplay.timezone}
                    connectedDevices={profileDisplay.connectedDevices}
                />
                <Engagements
                    score={profileDisplay.engagementScore}
                    total={profileDisplay.engagementTotal}
                    pct={profileDisplay.engagementPct}
                    rankingPublisher={profileDisplay.rankingPublisher}
                    rankingCountry={profileDisplay.rankingCountry}
                    rankingCountryName={profileDisplay.rankingCountryName}
                    rankingWorld={profileDisplay.rankingWorld}
                />
            </Box>
        );
    }

    function renderMiddleRow() {
        return (
            <Box sx={{ ...row, gridTemplateColumns: { xs: '1fr', lg: '2fr 1fr' } }}>
                <Collections publishers={collections} />
                <KeyInsightDetails
                    eventsThisMonth={profileDisplay.eventsThisMonth}
                    timeBooked={profileDisplay.timeBookedLabel}
                    percentOfMonth={profileDisplay.scheduleDensityPct}
                />
            </Box>
        );
    }

    return (
        <Box>
            {renderHeader()}
            {renderTopRow()}
            {renderMiddleRow()}
            <Box sx={{ mt: 2.5 }}>
                <Recommended publishers={recommendedPublishers} />
            </Box>
        </Box>
    );
}

export default observer(ProfilePanel);
